import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Award, FileText, Mic, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const copy = {
  en: {
    title: 'Scientific and Industry Visibility',
    items: [
      { Icon: Mic, text: 'PVMA 2024, Bacolod City (Opening keynote)', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2024, Cape Town (Opening keynote)', href: '/evidence' },
      { Icon: FileText, text: 'FECAVA EuroCongress 2025, Antwerp (Poster presentation)', href: '/evidence' },
      { Icon: Award, text: 'AVMA Convention 2025, Washington DC (Peer-reviewed presentation)', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2026, Tokyo (Oral presentation)', href: '/evidence' },
    ],
    cta: 'View all evidence and presentation materials',
  },
  uk: {
    title: 'Наукова та галузева присутність',
    items: [
      { Icon: Mic, text: 'PVMA 2024, Баколод (доповідь на відкритті)', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2024, Кейптаун (доповідь на відкритті)', href: '/evidence' },
      { Icon: FileText, text: 'FECAVA EuroCongress 2025, Антверпен (постерна презентація)', href: '/evidence' },
      { Icon: Award, text: 'AVMA Convention 2025, Вашингтон (рецензована презентація)', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2026, Токіо (усна доповідь)', href: '/evidence' },
    ],
    cta: 'Переглянути всі докази та презентаційні матеріали',
  },
  ja: {
    title: '学術および業界での発表',
    items: [
      { Icon: Mic, text: 'PVMA 2024、バコロド市（開会基調講演）', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2024、ケープタウン（開会基調講演）', href: '/evidence' },
      { Icon: FileText, text: 'FECAVA欧州大会2025、アントワープ（ポスター発表）', href: '/evidence' },
      { Icon: Award, text: 'AVMA大会2025、ワシントンDC（査読付き発表）', href: '/evidence' },
      { Icon: Mic, text: 'WVAC 2026、東京（口頭発表）', href: '/evidence' },
    ],
    cta: 'すべてのエビデンスと発表資料を見る',
  },
};

export default function ScientificVisibilitySection() {
  const { lang } = useLanguage();
  const c = copy[lang];
  const langSuffix = lang === 'en' ? '' : `?lang=${lang}`;

  return (
    <section className="section-padding">
      <div className="container-max max-w-4xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-foreground text-center mb-10"
        >
          {c.title}
        </motion.h2>
        <ul className="space-y-3">
          {c.items.map((item, i) => {
            const Icon = item.Icon;
            return (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="card-elevated p-0"
              >
                <Link
                  to={`${item.href}${langSuffix}`}
                  className="flex gap-3 items-start p-4 rounded-lg hover:bg-muted/50 transition-colors group"
                >
                  <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-primary" />
                  </div>
                  <p className="text-sm md:text-base text-foreground/90 leading-relaxed pt-1.5 group-hover:text-primary transition-colors">
                    {item.text}
                  </p>
                </Link>
              </motion.li>
            );
          })}
        </ul>
        <div className="flex justify-center mt-8">
          <Link
            to={`/evidence${langSuffix}#overview`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary text-primary-foreground font-semibold text-sm hover:bg-primary/90 transition-colors shadow-sm"
          >
            {c.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
